import type { RouteRecordRaw } from 'vue-router'
import { HelmPermission } from '@helm/services/api/client'

const orgRoutes: readonly RouteRecordRaw[] = [
    {
        path: `/organizations`,
        component: () => import('@helm/pages/Organizations/ListOrganizations.vue'),
        name: `organizations`,
        meta: {
            props: {
                sideNav: `organizations`
            }
        }
    },
    {
        path: `/organizations/cancellation-feedback`,
        component: () => import('@helm/pages/Organizations/ListRemovedOrganizations.vue'),
        name: `organizations.removed`,
        meta: {
            props: {
                sideNav: `organizations`
            }
        }
    },
    {
        path: `/organizations/:id`,
        component: () => import('@helm/pages/Organizations/OrganizationInfo.vue'),
        name: `organization`,
        meta: {
            props: {
                sideNav: `organization`
            }
        }
    },
    {
        path: `/organizations/:id/users`,
        component: () => import('@helm/pages/Organizations/OrganizationUsers.vue'),
        name: `organization.users`,
        meta: {
            props: {
                sideNav: `organization`
            }
        }
    },
    {
        path: `/organizations/:id/features`,
        component: () => import('@helm/pages/Organizations/OrganizationFeatures.vue'),
        name: `organization.features`,
        meta: {
            props: {
                sideNav: `organization`
            }
        }
    },
    {
        path: `/organizations/:id/giving`,
        component: () => import('@helm/pages/Organizations/OrganizationGiving.vue'),
        name: `organization.giving`,
        meta: {
            props: {
                sideNav: `organization`
            }
        }
    },
    {
        path: `/organizations/:id/mds`,
        component: () => import('@helm/pages/Organizations/OrganizationMds.vue'),
        name: `organization.mds`,
        meta: {
            props: {
                sideNav: `organization`
            }
        }
    },
    {
        path: `/organizations/:id/messaging`,
        component: () => import('@helm/pages/Organizations/OrganizationMessaging.vue'),
        name: `organization.messaging`,
        meta: {
            props: {
                sideNav: `organization`
            },
            roles: [HelmPermission.HELM_SMS_SETTINGS, HelmPermission.HELM_EMAIL_SETTINGS]
        }
    }
]

export default orgRoutes
